import { actionTypes } from './selectionsActions'

const initialState = {
  brandCode: 'R',
  shipCode: '',
  date: '',
  cur: 'USD',
}

function selectionsReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.SET_BRAND_CODE:
      return {
        ...state,
        brandCode: action.payload,
      }
    case actionTypes.SET_SHIP_CODE:
      return {
        ...state,
        shipCode: action.payload,
      }
    case actionTypes.SET_DATE:
      return {
        ...state,
        date: action.payload,
      }
    case actionTypes.SET_CURRENCY:
      return {
        ...state,
        cur: action.payload,
      }
    default:
      return state
  }
}

export default selectionsReducer
